import { getLocation, isEmceeConnect } from '../utils/package-connect-utils';
export function getExtensionIDFromURL(callback) {
  getLocation(location => {
    // for ex: 'com.atlassian.jira.emcee__admin-discover' will retrieved from url in case of Admin find new apps link
    const extensionID = location.split('?')[0].split('#')[0].split('/').slice(-2).join('__');
    callback(extensionID);
  });
}
export function getEmceeLocation(callback, mountPath) {
  // sample location = https://marketplace.atlassian.net/plugins/servlet/ac/com.atlassian.jira.emcee/app-requests?s=com.atlassian.jira.emcee__discover#!/discover
  // which should return
  // base = https://marketplace.atlassian.net/plugins/servlet/ac/com.atlassian.jira.emcee
  // fullURL = https://marketplace.atlassian.net/plugins/servlet/ac/com.atlassian.jira.emcee/app-requests
  getLocation(location => {
    const fullURL = location.split('?')[0].split('#')[0];
    const baseURL = isEmceeConnect() ? fullURL.split('/').slice(0, -1).join('/') : window.location.origin + mountPath;
    callback({
      fullURL,
      baseURL
    });
  });
}